import * as http from "@/utils/request";
import useSWR from "swr";
import { Chat, Block } from "@/interfaces/copilotTypes";
import { RFResponse } from "@/interfaces/common";
import rfLocalStore from "@/utils/rfLocalStore";
import { Bots } from "@/interfaces/enums";

// locale dev
// const baseUrl = process.env.NEXT_PUBLIC_COPILOT_API;
const baseUrl = process.env.NEXT_PUBLIC_BASE_API;

// >>>>>>>>>>>>>>>>> SWR >>>>>>>>>>>>>>>>>>>>>>>>.
/**
 * Get all ChatIds => SWR
 */
export const useChats = (bot: Bots) => {
  const url = `${baseUrl}/bot/api/chats?persona=${bot}`;

  const {
    data = [],
    error,
    mutate,
    isLoading,
  } = useSWR(
    url,
    async (url) =>
      await http
        .get<RFResponse<Chat[]>>(url, {
          headers: { uuid: rfLocalStore.getRockBotUUID() } as any,
        })
        .then((res) => res.data),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    chats: data,
    chat_id: data[0]?._id || "",
    error,
    mutate,
    isLoading,
  };
};

// >>>>>>>>>>>>>>>>>>  request >>>>>>>>>>>>>>>>>>>>>>>>>>.

/**
 * For long polling
 * get all chat blocks  api
 */
export const pollChatBlocks = async (chat_id: string) => {
  return await http
    .get<RFResponse<Chat>>(`${baseUrl}/bot/api/chats/${chat_id}`, {
      headers: { uuid: rfLocalStore.getRockBotUUID() } as any,
    })
    .then((res) => res.data);
};

/**
 *  post messages api
 *  TODO:
 */
export const sendMessage = async ({
  chat_id,
  message,
}: {
  chat_id: string;
  message: string;
}) => {
  return await http.post(
    `${baseUrl}/bot/api/chats/${chat_id}/blocks`,
    {
      message,
    },
    {
      headers: { uuid: rfLocalStore.getRockBotUUID() } as any,
    }
  );
};
/**
 *  Create New Chat api
 */
export const createNewChat = async (bot: Bots) => {
  return await http.post(
    `${baseUrl}/bot/api/chats?persona=${bot}`,
    { persona: bot },
    {
      headers: { uuid: rfLocalStore.getRockBotUUID() } as any,
    }
  );
};
